import { FC, Dispatch, SetStateAction } from 'react';
import { MenuConfig } from 'alurkerja-ui';
import { useLocation } from 'react-router-dom';
import { useGetMenu } from '@/utils/configs/menu';
import RenderLogo from './RenderLogo';
import Sidebar from '@/components/shared/sidebar/Sidebar';
import TenantList from '@/components/shared/header/TenantList';

interface MenuWrapperProps {
  children: JSX.Element;
  menu: MenuConfig;
  toggled: boolean;
}

interface ExtendedSidebarProps {
  toggled: boolean;
  setToggled: Dispatch<SetStateAction<boolean>>;
  menuWrapper: (props: MenuWrapperProps) => JSX.Element;
}

export const ExtendedSidebar: FC<ExtendedSidebarProps> = ({ setToggled, toggled, menuWrapper }) => {
  const { pathname } = useLocation();
  const { filteredMenu: menu } = useGetMenu();

  return (
    <div className="fixed left-0 top-16 z-50">
      <Sidebar
        logo={<RenderLogo />}
        workspace={<TenantList />}
        toggled={toggled}
        setToggled={setToggled}
        menuConfig={menu}
        currentPathName={pathname}
        menuWrapper={menuWrapper}
      />
    </div>
  );
};
